import * as React from "react";
import { Mk8sCreateForm } from "./form";

export const Mk8sCreateInitializer: React.FC = () => {
  return <Mk8sCreateForm />;
};
